import { render } from "./asegurados.vue?vue&type=template&id=e63559b0&scoped=true"
import script from "./asegurados.vue?vue&type=script&lang=js"
export * from "./asegurados.vue?vue&type=script&lang=js"

import "./asegurados.vue?vue&type=style&index=0&id=e63559b0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e63559b0"]])

export default __exports__